module.exports = __webpack_public_path__ + "static/media/slider_3.6579ccba.webp";